import React, { useCallback } from 'react'
import { getIn } from 'formik'

import DatePicker from '../../../../../../../../components/DatePicker'

import { CUSTOM_DATES, DATE } from '../../fields'

const BookedMediaCustomDatePicker = ({ formik, index }) => {
  const { values, setFieldValue } = formik

  const changeHandler = useCallback(
    value => {
      setFieldValue(`${CUSTOM_DATES}[${index}][${DATE}]`, value)
    },
    [index, setFieldValue]
  )

  return (
    <DatePicker
      isPastAllowed={true}
      value={getIn(values, `${CUSTOM_DATES}[${index}][${DATE}]`)}
      changeHandler={changeHandler}
    />
  )
}

export default BookedMediaCustomDatePicker
